module.exports = __webpack_public_path__ + "static/img/17063B_2_3_4_R_20180610_fit.bf5842f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17063B_2_3_4_R_20180610_fit.png
// module id = TVSt
// module chunks = 0